import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./../../../assets/scss/layoutweb.scss";
import logo from "./../../../assets/images/logo.png";
import matchstiq from "./../../../assets/images/matchstiq.webp";
import facebook from "./../../../assets/images/icons/facebook.svg";
import linkedIn from "./../../../assets/images/icons/linkedIn.svg";
import { footer_web, header_web } from "../../../locales/en";
import {
  COPYRIGHT,
  FUNDTAP_ABOUT_US_URL,
  FUNDTAP_CONTACT_URL,
  FUNDTAP_FEATURES_URL,
  FUNDTAP_LATEST_ARTICLE_URL,
  FUNDTAP_PARTNER_URL,
  FUNDTAP_POPULER_ARTICLE_URL,
  FUNDTAP_PRIVACY_POLICY_URL,
  FUNDTAPAUURL
} from "../../../utils/constants/appConstants";
import { LOGIN, SIGN_UP } from "../../../route/paths";

const Footerweb = () => {
  useEffect(() => {
    const getYearElement = document.getElementById("getYear");
    if (getYearElement) {
      const currentYear = new Date().getFullYear();
      getYearElement.textContent = currentYear;
    }
  }, []);
  return (
    <footer className="footer">
      <section className="footer-wrap">
        <div className="container-wrap">
          <div className="row-flex">
            <div className="left-section">
              <ul className="footer-logo-wrap">
                <li>
                  <Link className="footer-logo" to={FUNDTAPAUURL}>
                    <img src={logo} alt="logo" width="184" height="155" />
                  </Link>
                </li>
                <li>
                  <img
                    width="142"
                    height="166"
                    src={matchstiq}
                    className="size-full"
                    alt="matchstiq"
                  />
                </li>
              </ul>
            </div>
            <div className="right-section">
              <div className="row-flex">
                <div className="footer-details">
                  <div className="widget-title">{footer_web?.productTitle}</div>
                  <ul>
                    <li>
                      <Link to={FUNDTAP_FEATURES_URL}>{header_web?.link1}</Link>
                    </li>
                    <li>
                      <Link to={FUNDTAP_PARTNER_URL}>
                        {footer_web?.productLink?.link2}
                      </Link>
                    </li>
                    <li>
                      <Link to={SIGN_UP}>{footer_web?.productLink?.link3}</Link>
                    </li>
                    <li>
                      <Link to={LOGIN}>{footer_web?.productLink?.link4}</Link>
                    </li>
                  </ul>
                </div>
                <div className="footer-details">
                  <div className="widget-title">{header_web?.link4}</div>
                  <ul>
                    <li>
                      <Link to={FUNDTAP_LATEST_ARTICLE_URL}>
                        {footer_web?.resourceLink?.link1}
                      </Link>
                    </li>
                    <li>
                      <Link to={FUNDTAP_POPULER_ARTICLE_URL}>
                        {footer_web?.resourceLink?.link2}
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="footer-details">
                  <div className="widget-title">{footer_web?.companyTitle}</div>
                  <ul>
                    <li>
                      <Link to={FUNDTAP_ABOUT_US_URL}>
                        {footer_web?.companyLink?.link1}
                      </Link>
                    </li>
                    <li>
                      <Link to={FUNDTAP_CONTACT_URL}>
                        {footer_web?.companyLink?.link2}
                      </Link>
                    </li>
                    <li>
                      <Link to={FUNDTAP_PRIVACY_POLICY_URL}>
                        {footer_web?.companyLink?.link3}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="footer-bottom">
        <div className="container-wrap">
          <div className="row-flex">
            <div className="left-section">
              <div className="copyright-text">
                <p>
                  {COPYRIGHT} <span id="getYear" />
                  {footer_web?.footerBottom?.fundTap}
                </p>
              </div>
            </div>
            <div className="right-section">
              <div className="social-contact">
                <ul>
                  <li>
                    <Link to="/">
                      <img
                        src={facebook}
                        alt="facebook"
                        width="12"
                        height="20"
                      />
                    </Link>
                  </li>
                  <li>
                    <Link to="/">
                      <img
                        src={linkedIn}
                        alt="linkedIn"
                        width="20"
                        height="19"
                      />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="footer-round" />
      <div className="footer-ellipse" />
    </footer>
  );
};

export default Footerweb;
